import React, { useState, useEffect } from 'react'
import { Button, Flex, Table, Badge, Breadcrumb } from 'antd'
import api from '../../service/axios'
import { useToasts } from 'react-toast-notifications';
import {
    CheckOutlined,
    CloseOutlined,
    DollarCircleOutlined,
} from '@ant-design/icons';
import { userState } from '../../service/database'
import { useRecoilState } from 'recoil'
import dayjs from 'dayjs';
import { isMobile } from 'react-device-detect';



export const RegistradoFinanceiro = (props) => {

    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [data, setData] = useState(undefined)
    const [user,] = useRecoilState(userState)



    useEffect(() => {
        if (user) {
            console.log(user)
            consulta()
        }
    }, [])


    async function consulta() {
        try {
            setLoading(true)
            const result = await api.get('/api/v1.0/registrado/financeiro', {
                headers: {
                    'x-access-token': user?.token2
                }
            })
            setData(result.data)
            console.log(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }

        setLoading(false)
    }

    function getDescricaoProveniente(tipo) {
        switch (tipo) {
            case 1: return "Registro";
            case 2: return "Carteira";
            case 3: return "Anuidade";
            case 4: return "Juros";
            case 5: return "Multa";
            case 6: return "ART";
            case 7: return "Dívida Ativa";
            case 8: return "Licença Provisória";
            case 9: return "Certidão";
            case 10: return "2ª Via";
            case 11: return "Renovação de Licença Provisória";
            case 12: return "AFT";
            default:
                return ''
        }
    }


    return <Flex vertical gap={10}>

        <Breadcrumb items={[
            {
                title: <Flex align='center' gap={5}><DollarCircleOutlined />Financeiro</Flex>,
            }
        ]} />

        <Flex></Flex>
        <Flex>
            <Table id='tablesmall' loading={loading} size='small' dataSource={data} pagination={false} bordered style={{ width: '100%' }}>
                <Table.Column title="Vigencia" align='center' width={100} render={(txt, item, index) => {
                    return item.vigencia
                }} />
                <Table.Column title="Vencimento" align='center' width={110} render={(txt, item, index) => {
                    return dayjs(item.vencimento).format('DD/MM/YYYY')
                }} />

                <Table.Column title="Descrição" align='center' width={150} render={(txt, item, index) => {
                    return <Flex vertical>
                        <Flex flex={1} gap={5} >
                            <Flex flex={1}> {getDescricaoProveniente(item.provid)} </Flex>
                            <Flex vertical>
                                <Flex>R$ {(parseFloat(item.valor)).toFixed(2)}</Flex>
                            </Flex>
                        </Flex>
                    </Flex>
                }} />


                <Table.Column hidden={isMobile} title={"Desconto"} width={50} align='center' render={(txt, item, index) => {
                    let desc = 0
                    if (item.provid === 3 && parseFloat(item.desconto) > 0)
                        desc = parseFloat(item.desconto).toFixed(2)
                    return desc > 0 ? <span style={{ color: 'red' }}> -{desc} </span> : ""

                }} />

                <Table.Column hidden={isMobile} title={"Multa"} width={50} align='center' render={(txt, item, index) => {
                    return item.multa

                }} />

                <Table.Column hidden={isMobile} title={"Juros"} width={50} align='center' render={(txt, item, index) => {
                    return item.juros
                }} />


                <Table.Column title="Situação" width={120} align='center' render={(txt, item, index) => {
                    if (item.pago === 0)
                        return <Flex gap={5} align='center' justify='center'> <CloseOutlined style={{ color: 'red' }} />  aberto</Flex>
                    else if (item.pago === 1)
                        return <Flex gap={5} align='center' justify='center'> <CheckOutlined style={{ color: 'green' }} />  Pago</Flex>
                    else if (item.pago === 2)
                        return <Flex gap={5} align='center' justify='center'> <Badge color='magenta' />  Abonado</Flex>
                    else
                        return ""
                }} />
                <Table.Column hidden={isMobile} title="Pago" width={120} align='center' render={(txt, item, index) => {
                    if (item.pago === 0)
                        return ""
                    else if (item.pago === 1)
                        return dayjs(item.datapagamento).format('DD/MM/YYYY')
                    else if (item.pago === 2)
                        return dayjs(item.datapagamento).format('DD/MM/YYYY')
                    else
                        return ""

                }} />
                <Table.Column title={"Total"} width={100} align='center' render={(txt, item, index) => {
                    let desc = 0
                    if (item.provid === 3 && parseFloat(item.desconto) > 0)
                        desc = parseFloat(item.desconto).toFixed(2)
                    return <Flex justify='flex-end' style={{ fontWeight: 'bold' }}>R$ {(parseFloat(item.total) - desc).toFixed(2)}</Flex>

                }} />
                <Table.Column hidden={true} title="" width={100} align='center' render={(txt, item, index) => {

                    if (dayjs().year() === item.vigencia && item.provid === 3 && item.pago === 0)
                        return <Button size='small' type='link' onClick={() => {
                            // window.location.href = user.boleto
                            window.open(user.boleto, '_blank');
                        }}>Download</Button>
                    else
                        return ""
                }} />



            </Table>
        </Flex>
    </Flex>


}